import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSheet = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.1231 23H7.37685C5.51143 23 4 21.5018 4 19.6527V4.34732C4 2.49822 5.51143 1 7.37685 1H15.8423L20.5 5.63778V19.6527C20.5 21.5018 18.9886 23 17.1231 23Z",
			fill: "#00AC54"
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20.5 5.63997H16.7994C16.2755 5.63997 15.8493 5.21983 15.8493 4.70041L15.8423 1.0022",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4024 17.3925H7.09717V9.32202H17.4024V17.3925ZM7.79583 16.7H16.7037V10.0146H7.79583V16.7Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.98967 9.66846H9.29102V17.0464H9.98967V9.66846Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.0533 14.5925H7.44678V15.2851H17.0533V14.5925Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.0533 11.73H7.44678V12.4225H17.0533V11.73Z",
			fill: "white"
		})
	]
});
export default SvgSheet;
